import { render, staticRenderFns } from "./AIChatMessage.vue?vue&type=template&id=28c60398&scoped=true"
import script from "./AIChatMessage.vue?vue&type=script&lang=js"
export * from "./AIChatMessage.vue?vue&type=script&lang=js"
import style0 from "./AIChatMessage.vue?vue&type=style&index=0&id=28c60398&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c60398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c60398')) {
      api.createRecord('28c60398', component.options)
    } else {
      api.reload('28c60398', component.options)
    }
    module.hot.accept("./AIChatMessage.vue?vue&type=template&id=28c60398&scoped=true", function () {
      api.rerender('28c60398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/AIChatMessage.vue"
export default component.exports